import hyperdom from 'hyperdom'
import customSelect from '../../../customSelect.jsx'
import responsiveRender from '../../../responsiveRender.js'
import PassengersDetailsSchema from './passengersDetailsDayTourSchema.js'
import {PassengersDetails} from "../../../defaultFlow/index.js"

export default class PassengersDetailsDayTour extends PassengersDetails {
  constructor (options) {
    super(options)
    this.schema = new PassengersDetailsSchema({
      hasFlights: () => this.quoteCriteria.hasFlights(),
      hasPromisedFlights: () => this.quoteCriteria.hasPromisedFlights(),
      config: this.config,
      departure: this.departure,
    }).buildSchema()
  }

  renderPassportInformationText () {
    const passportInformationText = this.config.dayTourFlow.passportInformationText
    return passportInformationText
      ? <span className='passenger-details__passport-information'>{passportInformationText}</span>
      : undefined
  }

  submit () {
    const countries = this.countries()
    const leadPassenger = this.quoteCriteria.leadPassenger
    let country = countries[leadPassenger.phoneNumber.countryCode.toLowerCase()] || {}
    leadPassenger.phoneNumber.internationalCode = country.internationalCallingCode || this.config.internationalCode

    this.resetScrolledToError()
    if (!this.validate().valid) {
      return false
    }
    return true
  }

  renderContactDetails () {
    const {leadPassenger} = this.quoteCriteria
    const countries = this.countries()
    const emailField = <div className='form-item-email-address'>
      {this.renderTextField({
        autocomplete: 'email',
        binding: [leadPassenger, 'emailAddress'],
        dataLayerId: 'pax-email-address',
        id: `emailAddress`,
        label: 'Email*',
        name: 'emailAddress',
        onblur: (event) => {
          event.target.value = event.target.value.trim()
          const isValid = this.isFieldValid(leadPassenger, 'emailAddress')
          isValid && this.scrollToAndFocus('#number')
        },
        type: this.browserCapabilities.input.email,
      })}
      {this.renderValidationError(leadPassenger, 'emailAddress', 'emailAddress')}
    </div>
    const phoneFields = (phoneNumber, placeholder) => <div className='form-item-telephone'>
      <div className='form-item-country-code'>
        <label htmlFor='pax-phone-country-code' className='u-visually-hidden'>Country Code</label>
        {customSelect({
          classes: {
            wrapper: 'pax-phone-country-code-select',
          },
          inputBinding: {
            get: () => phoneNumber.countryCode
              ? countries[phoneNumber.countryCode.toLowerCase()].internationalCallingCode
              : undefined,
            set: () => {},
          },
          selectBinding: [phoneNumber, 'countryCode', () => {
            document.querySelector('#number').focus(),
            this.refresh()
          }],
          selectId: 'pax-phone-country-code',
          selectOnBlur: () => this.fieldVisited(phoneNumber, 'countryCode', 'pax-phone-country-code'),
          options: Object.keys(countries).map(countryCode => {
            const country = countries[countryCode]
            return {
              value: countryCode.toUpperCase(),
              display: `${country.name} (${country.internationalCallingCode})`,
            }
          }),
        })}
        {this.renderValidationError(phoneNumber, 'internationalCode')}
      </div>
      <div className='form-item-phone-number'>
        {this.renderTextField({
          autocomplete: 'tel-national',
          binding: {
            get: () => {
              let number = (phoneNumber.areaCode) ? phoneNumber.areaCode : ''
              number += (phoneNumber.number) ? new String(phoneNumber.number) : ''
              return number
            },
            set: (value) => {
              const areaCode = value.substring(0, 3)
              const number = value.substring(3)
              phoneNumber.areaCode = areaCode
              phoneNumber.number = number
            },
          },
          dataLayerId: 'pax-phone-number',
          id: `number`,
          label: `${placeholder}*`,
          modelBinding: [phoneNumber, 'number'],
          name: 'number',
          onblur: () => {
            const isValid = this.isFieldValid(phoneNumber, 'number')
            isValid && this.scrollToAndFocus('#city')
          },
        })}
        {this.renderValidationError(phoneNumber, 'number')}
      </div>
    </div>
    return <div className='o-accent-box' id='lead-passenger__contact-details'>
      <h3 className="form-item-header">Contact Details</h3>
      <div className="o-form-item__container" id='leadPassengerContact'>
        {responsiveRender('small',
          () => [emailField, phoneFields(leadPassenger.phoneNumber, 'Phone number')],
          () => [phoneFields(leadPassenger.phoneNumber, 'Phone number'), emailField]
        )}
      </div>
    </div>
  }
}
